import type { EsMrpaxeStaticFileIdFormat } from '../model.ts'

/**
 * Axeria's general terms ("CG – MRPAXERIA ES – 001") and IPID, delivered by Paul on 2026-10-15. No broker's nota
 * informativa, unlike es-mrpw: Axeria's product does not distribute one.
 */
export const esMrpaxeStaticFilesIds_v1_0_0 = [
  'es-mrp-axeria-general-terms-v1_0_0',
  'es-mrp-axeria-ipid-v1_0_0',
] as const satisfies EsMrpaxeStaticFileIdFormat[]
